import { CLAIM_PROFILE, LOAD_PRO } from './types';

export function claimProfile(email) {
  return {
    type: CLAIM_PROFILE,
    payload: {
      email,
    },
  };
}

export function loadPro(proId) {
  return {
    type: LOAD_PRO,
    payload: {
      proId,
    },
  };
}
